import React from 'react';
import type { FormikProps } from 'formik';
import { ButtonV2 } from '@withjoy/joykit';
import { Remove } from '@withjoy/joykit/icons';
import type { Contacts, ContactInputFields } from '@apps/guest/contactCollector/shared/types';
import type { IframeContacts, IframeContactInputFields } from '@apps/guest/contactCollector/shared/types';

interface RemoveMemberProps
  extends Readonly<{
    formik: FormikProps<Contacts> | FormikProps<IframeContacts>;
    remove: (index: number) => ContactInputFields | IframeContactInputFields | undefined;
    index: number;
  }> {}

export const RemoveMember: React.FC<RemoveMemberProps> = ({ remove, index }) => (
  <ButtonV2
    startIcon={Remove}
    variant="ghost"
    paddingLeft={0}
    minWidth={0}
    paddingRight="0.5rem"
    justifyContent="flex-start"
    onClick={() => remove(index)}
  />
);
